var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('transition',{attrs:{"name":"cookie"}},[_c('img',{ref:"cookie",staticClass:"cookie",attrs:{"src":_vm.imgSrc,"loading":"lazy","alt":"","height":"200"},on:{"click":_vm.clickCookie}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }